export default "__VITE_ASSET__DQw81CBp__"